import Layout from "../../layout/main";
import WalletWithdrawalReports from "../../components/walletWithdrawalReports";
/**
 * WalletWithdrawalReportsPage
 *
 * صفحه گزارش ها برداشت از کیف پول.
 * رندر کامپوننت WalletWithdrawalReports داخل لایه اصلی Layout برای نمایش گزارش ها برداشت.
 *
 * @returns JSX.Element
 */

const WalletWithdrawalReportsPage = () => {
  return (
    <Layout>
      <WalletWithdrawalReports />
    </Layout>
  );
};

export default WalletWithdrawalReportsPage;
